export default {"src":"/_next/static/media/growin-logo.241b3b76.svg","height":75,"width":75,"blurWidth":0,"blurHeight":0};